export default __webpack_public_path__ + "static/media/acguy.83a63d47.webp";